import { render } from "./AsCoursePreview.vue?vue&type=template&id=0bf5db43&ts=true"
import script from "./AsCoursePreview.vue?vue&type=script&lang=ts"
export * from "./AsCoursePreview.vue?vue&type=script&lang=ts"

import "./AsCoursePreview.vue?vue&type=style&index=0&id=0bf5db43&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__